import axios from 'axios';
import { LocaleNames, LoginType } from '../enum';

/**
 * cache type of connected wallet.
 * @param type
 */
export const storeLoginType = (type: LoginType) => {
  localStorage.setItem(LocaleNames.LOGIN_TYPE, type);
};

// todo move to cache.ts.

/**
 * get type of connected wallet.
 */
export const getLoginType = () => localStorage.getItem(LocaleNames.LOGIN_TYPE);

/**
 * cache connect wallet ont id.
 * @param ontId
 */
export const storeLoginOntId = (ontId: string) => {
  localStorage.setItem(LocaleNames.ONT, ontId);
};

/**
 * get connect walelt ont id.
 */
export const getLoginOntId = () => localStorage.getItem(LocaleNames.ONT) || '';

/**
 * cache user score.
 * @param score
 */
export const storeCacheScore = (score: string) => {
  localStorage.setItem(LocaleNames.SCORE_CACHE, score);
};

/**
 * get user score from cache.
 */
export const getCacheScore = () => localStorage.getItem(LocaleNames.SCORE_CACHE) || '';

export const getSign = () => sessionStorage.getItem(LocaleNames.ONT_SIGN) || '';

export const getOnt = () => sessionStorage.getItem(LocaleNames.ONT) || '';

export const getAuthParams = () => ({
  did: getOnt(),
  didsign: getSign(),
});

export const setToken = (token: string) => {
  sessionStorage.setItem(LocaleNames.Token, token);
};

export const getToken = () => sessionStorage.getItem(LocaleNames.Token);

export const setRequestToken = (token: string) => {
  axios.defaults.headers.token = token;
};

/**
 * clear user cache when logout.
 */
export const clearStatus = () => {
  localStorage.removeItem(LocaleNames.JWT_CACHE_NAME);
  localStorage.removeItem(LocaleNames.LOGIN_TYPE);
  localStorage.removeItem(LocaleNames.ONT);
  localStorage.removeItem(LocaleNames.SCORE_ID_CACHE);
  localStorage.removeItem(LocaleNames.SCORE_CACHE);
  sessionStorage.removeItem(LocaleNames.ONT_SIGN); // todo remove
  sessionStorage.removeItem(LocaleNames.Token);
};
